import { Body } from '@/presenters/Body';
import { ref } from 'vue';
import { OnMounted } from '@studyportals/vue-platform';
import { BodyPresenter } from '@/presenters/BodyPresenter';
import { PlatformIntegration } from '../../../platform/PlatformIntegration';

export class OverviewCB implements OnMounted {
	public readonly bodies = ref<readonly Body[]>([]);
	public readonly sorting = { prop: 'formattedId', order: 'descending' };

	public async mounted(): Promise<void> {
		await this.retrieveBodies();
	}

	public toCreateBody(): void {
		PlatformIntegration.instance.router.toCreate();
	}

	private async retrieveBodies(): Promise<void> {
		this.bodies.value = await BodyPresenter.retrieveAll();
	}
}
